import React from "react";
import GitHubIcon from "@material-ui/icons/GitHub";
import LinkedInIcon from "@material-ui/icons/LinkedIn";
import Link from '@material-ui/core/Link';
import "../styles/Footer.css";

function Footer() {
  return (
    <div className="w-full h-[200px] flex justify-center items-center flex-col pt-2.5 bottom-0 bg-[#f07364] dark:bg-[#0f193d]">
      <div className="socialMedia">
      <Link href="https://www.linkedin.com/in/mohamedoulal/" target="_blank" >
          <LinkedInIcon />
        </Link>
        <Link href="https://github.com/ElAyachie" target="_blank" >
          <GitHubIcon/>
        </Link>
      </div>
      <p className="text-[white]"> &copy; {new Date().getFullYear()} Mohamed Oulal</p>
    </div>
  );
}

export default Footer;
